import React from "react";

const EmptyOdds = ({ compact = false }) => {
  if (compact) {
    return ["#72bbef", "#faa9ba"].map((background) => (
      <dd key={background} style={{ display: "flex", width: "100%", minWidth: 0, minHeight: "41px", margin: 0, padding: "3px", border: 0, boxSizing: "border-box" }}>
        <span style={{ width: "100%", background, border: "1px solid #fff", borderRadius: "3px" }} />
      </dd>
    ));
  }
  return (
    <dd class="backlay_box">
      <dl class="back-gradient">
        <dd id="back_3" class="mode-land">
          <p></p>
        </dd>
        <dd id="back_2" class="mode-land">
          <p></p>
        </dd>
        <dd id="back_1" class="">
          <a href=""></a>
        </dd>
      </dl>
      <dl class="lay-gradient">
        <dd id="lay_1" class="">
          <a href=""></a>
        </dd>
        <dd id="lay_2" class="mode-land">
          <p></p>
        </dd>
        <dd id="lay_3" class="mode-land">
          <p></p>
        </dd>
      </dl>
    </dd>
  );
};

export default EmptyOdds;
